import { render, staticRenderFns } from "./Einladung.vue?vue&type=template&id=648e2454&scoped=true"
import script from "./Einladung.vue?vue&type=script&lang=js"
export * from "./Einladung.vue?vue&type=script&lang=js"
import style0 from "./Einladung.vue?vue&type=style&index=0&id=648e2454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e2454",
  null
  
)

export default component.exports